// extracted by mini-css-extract-plugin
export var label = "_jd-2";
export var slideContainer = "_jd-0";
export var slider = "_jd-1";